import { render, staticRenderFns } from "./TablaInscripcionesPrograma.vue?vue&type=template&id=1b1ba40f"
import script from "./TablaInscripcionesPrograma.vue?vue&type=script&lang=js"
export * from "./TablaInscripcionesPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports